import { Component, forwardRef, inject, Input, OnInit, input, output, viewChild } from "@angular/core";
import { NgForm, NgModel, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { SelectItem } from "primeng/api";
import { SharedControl } from "../../classes/sharedcontrol";
import { PurchaseOrderStatusPipe } from '../../pipes/purchaseorderstatus.pipe';
import { PurchaseOrderStatus } from '../../types';

import { ErrormessageComponent } from "../validation/errormessage/errormessage.component";
import { MultiSelectModule } from "primeng/multiselect";
import { FluidModule } from "primeng/fluid";

@Component({
    selector: "pcp-purchaseorderstatus-multiselect",
    templateUrl: "./pcp-purchaseorderstatus-multiselect.component.html",
    styleUrls: [],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => PCPPurchaseOrderStatusMultiSelectComponent),
        }
    ],
    standalone: true,
    imports: [MultiSelectModule, FormsModule, FluidModule, ErrormessageComponent]
})
export class PCPPurchaseOrderStatusMultiSelectComponent extends SharedControl implements OnInit {
  private purchaseOrderStatusPipe = inject(PurchaseOrderStatusPipe);
  
  purchaseOrderOptions: SelectItem[] = [];
  readonly purchaseOrderStatusSelection = viewChild<NgModel>("purchaseOrderStatusSelection");

  readonly placeholder = input<string>("No Status Selected");
  // TODO: Skipped for migration because:
  //  This input is inherited from a superclass, but the parent cannot be migrated.
  @Input() disabled: boolean = false;
  readonly isOneOfManyRequired = input<boolean>(false);
  readonly maxSelectedLabels = input<number>(1);
  readonly parentForm = input<NgForm>(null);
  readonly purchaseOrderStatuses = input<PurchaseOrderStatus[]>([]);
  readonly required = input<boolean>(false);
  readonly selectionLimit = input<number>(null);
  readonly appendTo = input<string>(undefined);

  _selectedPurchaseOrderStatuses: PurchaseOrderStatus[] = [];

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set selectedPurchaseOrderStatuses(statuses: PurchaseOrderStatus[]){
    this._selectedPurchaseOrderStatuses = statuses;
    this.propagateChange(this._selectedPurchaseOrderStatuses);
  }

  get selectedPurchaseOrderStatuses() : PurchaseOrderStatus[] {
    return this._selectedPurchaseOrderStatuses;
  }
  
  readonly selectedPurchaseOrderStatusesChange = output<PurchaseOrderStatus[]>();

  constructor() {
    super();
  }

  ngOnInit() {
    const selectionLimit = this.selectionLimit();
    if (selectionLimit && selectionLimit <= 0) {
      throw new TypeError("PCPPurchaseOrderStatusSelector: 'selectionLimit' must be left null for no limit or set greater than 0");
    }

    this.purchaseOrderOptions = this.purchaseOrderStatuses().map((purchaseOrderStatus) => {
      return { label: this.purchaseOrderStatusPipe.transform(purchaseOrderStatus), value: purchaseOrderStatus.valueOf() };
    });
  }

  writeValue(obj: any) {
    this.selectedPurchaseOrderStatuses = obj;
  }

  onChange() {
    this.selectedPurchaseOrderStatusesChange.emit(this.selectedPurchaseOrderStatuses);
  }
}
